<template>
  <div>
    <QS-h4-title title="订单付款信息" />
    <!-- 付款信息列表 -->
    <QS-common-table
      v-loading="loading"
      :columns="columns"
      :pagination="pagination"
      :data="list"
      @change="pageChange"
    ></QS-common-table>
  </div>
</template>

<script>
import { getPaymentList } from '@/api/domain/returnLease'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'
import config from './config'

export default {
  inject: ['orderData'],
  data() {
    const { columns, pagination } = config.call(this)
    return {
      columns,
      pagination,
      loading: false,
      list: [],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.getList()
  },
  methods: {
    // 应收列表
    async getList() {
      this.loading = true
      const { code, data } = await getPaymentList({
        sourceOrderId: this.orderData.id,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      })
      this.loading = false
      if (code !== 1) return
      this.list = data.items
        ? data.items.map((item) => {
          return {
            ...item,
            changeState: selectOption.payeechange[item.changeState],
            payState: selectOption.paymentStatusDict[item.payState],
            payType: this.formatEnumeration(this.freeTypeList)[item.payType],
          }
        })
        : []
      this.pagination.total = data.totalNum
    },
    pageChange(payload) {
      this.pagination.pageNum = payload.pagination.pageNum
      this.pagination.pageSize = payload.pagination.pageSize
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .disableSelection .cell .el-checkbox__inner {
    display: inline-block;
    position: relative;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-color: #DCDFE6;
    background-color: #F5F7FA;
    cursor: not-allowed;
    z-index: 1;
}
</style>
